module.exports = __webpack_public_path__ + "img/Priest-human-f-70.94b7856e.gif";